import { AsyncPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import { NgCircleProgressModule } from "ng-circle-progress";
import { HighchartsChartModule } from "highcharts-angular/lib/highcharts-chart.module";
import { NgxBarcodeModule } from "ngx-barcode/ngx-barcode.module";
export const  materialModules = [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    NgbModule,
    ToastrModule.forRoot({ timeOut: 1500,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,}),
    MatFormFieldModule,
    MatInputModule,
    MatSidenavModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule ,
    MatDividerModule, 
    MatToolbarModule, 
    MatButtonModule, 
    MatSidenavModule,
    MatPaginatorModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatTableModule,
    MatDatepickerModule,
    MatSortModule,
    MatCheckboxModule,
    NgbModule,
    FormsModule,
    AsyncPipe,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 8,
      innerStrokeWidth: 8,
      animationDuration: 300,
      "maxPercent": 100,
      "showSubtitle" : false,
      "animateTitle": false,
      "animation" : true,
      "showUnits": true,
      "showBackground": true,
      "clockwise": false,
      "startFromZero": true,
      "lazy": false}
      ),
  ];
